// Global site configuration for SecurityStaging.de
// Phone number is a placeholder - user will update later.

export const SITE = {
  brand: "SecurityStaging.de",
  brandShort: "SecurityStaging",
  tagline: "Alarmanlagen-Staging für leerstehende Immobilien",
  url: process.env.REACT_APP_SITE_URL || "https://securitystaging.de",
  language: "de-DE",
};

// Phone (real contact data)
export const PHONE = {
  display: "0231 39085116",
  tel: "+4923139085116",
  hours: "Mo – Sa · 08:00 – 20:00 Uhr",
};

// Company information
export const COMPANY = {
  name: "Security Staging",
  owner: "Andreas Schössow",
  street: "Wichlinghofer Markstraße 22",
  postalCode: "44265",
  city: "Dortmund",
  country: "DE",
  countryName: "Deutschland",
  email: "info@securitystaging.de",
  vatId: "DE361359214",
};

export const HERO_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_f205f6f7-01a2-460b-8094-8c1f9f1b0c41/artifacts/axe0ug0r_VID-20260712-WA0001.mp4";

export const HERO_POSTER =
  "https://images.unsplash.com/photo-1615816646372-cb8673878757?w=1600&q=85&auto=format&fit=crop";

// NRW cities are the top SEO/GEO priority.
export const NRW_CITIES = [
  "Dortmund",
  "Düsseldorf",
  "Köln",
  "Essen",
  "Duisburg",
  "Bochum",
  "Wuppertal",
  "Bielefeld",
  "Bonn",
  "Münster",
  "Mönchengladbach",
  "Gelsenkirchen",
  "Aachen",
  "Krefeld",
  "Oberhausen",
  "Hagen",
  "Hamm",
  "Mülheim an der Ruhr",
  "Herne",
  "Solingen",
  "Leverkusen",
  "Neuss",
  "Paderborn",
  "Recklinghausen",
  "Bottrop",
  "Remscheid",
  "Moers",
  "Siegen",
  "Bergisch Gladbach",
  "Witten",
];

// Additional major German cities outside NRW – covered but secondary priority.
export const OTHER_CITIES = [
  "Berlin",
  "Hamburg",
  "München",
  "Frankfurt am Main",
  "Stuttgart",
  "Leipzig",
  "Bremen",
  "Dresden",
  "Hannover",
  "Nürnberg",
];

// Combined list for JSON-LD serviceArea and sitemap
export const CITIES = [...NRW_CITIES, ...OTHER_CITIES];

export const NAV_ITEMS = [
  { id: "security-staging", label: "Was ist das?" },
  { id: "benefits", label: "Vorteile" },
  { id: "process", label: "Ablauf" },
  { id: "services", label: "System" },
  { id: "coverage", label: "Deutschlandweit" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Kontakt" },
];

export const FAQS = [
  {
    q: "Was ist Security Staging genau?",
    a: "Security Staging ist die Ergänzung zum klassischen Home Staging: Statt Möbel und Deko installieren wir eine vollständige, professionelle Alarmanlage in Ihrer leerstehenden Immobilie – als Schutz vor Einbruch, Wasser und Feuer und als starkes Verkaufsargument in Exposé und Besichtigung.",
  },
  {
    q: "Wie lange dauert die Installation?",
    a: "Dank moderner Funk-Technik ist die Anlage in der Regel in unter einer Stunde einsatzbereit. Es gibt keine Kabelverlegung und keine Schmutzarbeiten.",
  },
  {
    q: "Bleiben nach dem Verkauf Spuren an Wänden zurück?",
    a: "Nein. Die Komponenten werden spurlos montiert und lassen sich rückstandsfrei entfernen – oder direkt vom Käufer als bezugsfertige Sicherheitslösung übernehmen.",
  },
  {
    q: "In welchen Städten und Regionen sind Sie aktiv?",
    a: "Unser Schwerpunkt liegt in Nordrhein-Westfalen: Dortmund, Düsseldorf, Köln, Essen, Duisburg, Bochum, Wuppertal, Bielefeld, Bonn, Münster, Mönchengladbach, Gelsenkirchen, Aachen, Krefeld, Oberhausen und viele weitere NRW-Städte. Darüber hinaus betreuen wir bundesweit Objekte – von Hamburg über Berlin und Frankfurt bis nach München.",
  },
  {
    q: "Für welche Immobilien eignet sich Security Staging?",
    a: "Für Wohnungen, Einfamilienhäuser, Villen, Neubauten und Gewerbeobjekte – überall dort, wo Leerstand während der Vermarktungsphase ein Risiko oder eine verpasste Chance darstellt.",
  },
  {
    q: "Ist die Anlage auch für den Käufer nutzbar?",
    a: "Ja, das ist einer der Kernvorteile: Käufer übernehmen die eingerichtete Alarmanlage bezugsfertig – ein Premium-Argument im Exposé und ein echter Mehrwert.",
  },
  {
    q: "Was schützt die Anlage konkret?",
    a: "Einbruch (Tür-/Fensterkontakte, Bewegungsmelder, Sirene), Wasserschäden (Wassermelder), Feuer (Rauch-/Brandmelder) sowie optional Videoüberwachung – alles per App steuerbar.",
  },
  {
    q: "Wie erhalte ich ein Angebot?",
    a: "Rufen Sie uns direkt an. Wir besprechen Objekt, Ziel der Vermarktung und Umfang – und Sie erhalten ein transparentes, unverbindliches Angebot für Ihr Security Staging.",
  },
];
